import { get } from "lodash";

export const shouldShowLeasingEODTrigger = loan => Boolean(get(loan, "covenants.leasingEODTrigger"));

export const shouldShowLeasingEODCure = loan => Boolean(get(loan, "covenants.leasingEODCure"));

export const shouldShowLeasingCovenants = loan => Boolean(get(loan, "covenants.leasingCovenants"));

export const shouldShowLeasingRestrictions = loan => Boolean(get(loan, "covenants.leasingRestrictions"));

export const shouldShowLeasingMisc = loan => Boolean(get(loan, "covenants.leasingMisc"));
